import { render, staticRenderFns } from "./AppDownload.vue?vue&type=template&id=10930e1d&"
import script from "./AppDownload.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppDownload.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AppDownload.vue?vue&type=style&index=0&id=10930e1d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports